import { useEffect, useState } from 'react';
import { navItems } from '@/mocks/site';

interface HeaderProps {
  onMenuOpen: () => void;
}

export default function Header({ onMenuOpen }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const onLight = scrolled;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,box-shadow] duration-500 ${
        onLight
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-300/70'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="flex h-16 items-center justify-between gap-4 px-5 md:h-20 md:px-8">
        <a href="#top" className="flex items-baseline gap-2.5 md:gap-3 cursor-pointer">
          <span
            className={`font-heading text-lg font-black tracking-[0.06em] transition-colors duration-500 md:text-xl ${
              onLight ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            H.Y企画
          </span>
          <span
            className={`hidden text-[9px] en-label transition-colors duration-500 sm:block ${
              onLight ? 'text-foreground-500' : 'text-background-50/80'
            }`}
          >
            EVENT OFFICIAL SITE
          </span>
        </a>

        <nav className="hidden items-center gap-6 lg:flex xl:gap-8">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`group relative cursor-pointer text-[11px] en-label transition-colors duration-300 ${
                onLight
                  ? 'text-foreground-700 hover:text-primary-600'
                  : 'text-background-50/85 hover:text-background-50'
              }`}
            >
              {item.en}
              <span
                className={`absolute -bottom-1.5 left-0 h-px w-full origin-left scale-x-0 transition-transform duration-500 group-hover:scale-x-100 ${
                  onLight ? 'bg-primary-500' : 'bg-background-50'
                }`}
              />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#vendor"
            className="hidden cursor-pointer items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-[12px] font-bold text-background-50 whitespace-nowrap transition-all duration-300 hover:bg-primary-600 lg:inline-flex"
          >
            <i className="ri-store-2-line text-sm" aria-hidden="true" />
            出店申込
          </a>

          <button
            type="button"
            onClick={onMenuOpen}
            aria-label="メニューを開く"
            className="flex h-10 w-10 cursor-pointer items-center justify-center transition-colors duration-300 lg:hidden"
          >
            <span className="flex w-6 flex-col items-end gap-[5px]">
              <span className={`h-[1.5px] w-6 transition-colors duration-500 ${onLight ? 'bg-foreground-900' : 'bg-background-50'}`} />
              <span className={`h-[1.5px] w-6 transition-colors duration-500 ${onLight ? 'bg-foreground-900' : 'bg-background-50'}`} />
              <span className={`h-[1.5px] w-4 transition-colors duration-500 ${onLight ? 'bg-foreground-900' : 'bg-background-50'}`} />
            </span>
          </button>
        </div>
      </div>
    </header>
  );
}